import { excelSerialToJsDate, javascriptDateToMMDDYYYY, javascriptDateToYYYYMMDD } from '../helpers/date-helpers';
import { isSupportedDataType, isValidDateInput, isValidExchangeTickerSymbol } from '../helpers/args-validators';
import { FunctionCallCache } from '../helpers/functionCallCache';
import { FunctionLocationTracker } from '../helpers/functionLocationTracker';
import { KeyBuilder } from '../helpers/keyBuilder';
const SUPPORTED_DATETYPES = [
    'Data Source Information_Name of Uploader',
    'Data Source Information_Primary Data Source',
    'Data Source Information_Filing Date',
    'Data Source Information_Filing Type',
    'Data Source Information_Filing Link',
    'Data Source Information_Period End',
    'Data Source Information_Period End Date',
    'Data Source Information_Financial Year',
    'Data Source Information_Financial Year Date',
    'Data Source Information_Financial Statement Currency',
    'Data Source Information_Numerical Scale_Share Counts',
    'Data Source Information_Numerical Scale_Currency Values',
    'Data Source Information_Numerical Scale_Share Price',
    'Data Source Information_Comments',
];
function validateArgs(symbol, dataType, dataSource, date) {
    if (!isValidExchangeTickerSymbol(symbol)) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid symbol (expected format: EXCHANGE:TICKER)');
    }
    if (dataSource.length != 3) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid data source (expected 3 values)');
    }
    if (!isSupportedDataType(SUPPORTED_DATETYPES, dataType)) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid data type');
    }
    if (!isValidDateInput(String(date))) {
        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, 'Invalid date');
    }
    return true;
}
let delegate = () => {
    throw new CustomFunctions.Error(CustomFunctions.ErrorCode.notAvailable, 'Initializing… press F9 to recalc.');
};
export function setCapitalizationActualsDelegate(fn) {
    delegate = fn;
}
export function capitalizationActualsWrapper(dataType, dateSource, symbol, date, invocation) {
    return delegate(dataType, dateSource, symbol, date, invocation);
}
export function capitalizationActualsImpl(dataType, dataSource, symbol, date, invocation) {
    const flatDataSource = dataSource.flat();
    validateArgs(symbol, dataType, flatDataSource, date);
    const javascriptDate = String(date).includes('/') ? new Date(date) : excelSerialToJsDate(Number(date));
    const queryDate = javascriptDateToYYYYMMDD(javascriptDate);
    const cache = FunctionCallCache.getInstance();
    const tracker = FunctionLocationTracker.getInstance();
    const args = { dataType, dataSources: flatDataSource, symbol, date: queryDate };
    const key = KeyBuilder.build('capitalization_actuals', args);
    cache.registerByKey(key, { functionName: 'capitalization_actuals', params: args });
    if (invocation?.address) {
        // the key contains the function name and args
        tracker.registerCell(key, invocation.address, `=ALPHA.CAPITALIZATION_ACTUALS("${dataType}", "...", "${symbol}", "${javascriptDateToMMDDYYYY(javascriptDate)}")`);
        cache.setAutoRefresh(key);
    }
    return cache.getValueForExcelByKey(key);
}
//# sourceMappingURL=capitalizationActuals.js.map